export default __webpack_public_path__ + "static/illustration-operating-system-e18dd7832cdf800e07f5288578dc5545.svg";